module.exports = __webpack_public_path__ + "img/5.a91e4742.jpg";